import { h, Component } from "preact";
import { connect } from "react-redux";
import config from "../config";
import { css } from "emotion";
import Loadable from "preact-loadable";
import Zoom from "../routes/seatingMap/Zoom";
import { getAllSeatingMaps } from "../state/actions/seatingMapActions";

let SeatingMap;

const seatingMapStyle = css({
  width: "80vw",
  height: "80vh",
  position: "relative",
  "@media(max-width: 600px)": {
    width: "100vw",
    height: "calc(100vh - 56px)"
  }
});
const legendStyle = css({
  zIndex: 10,
  position: "absolute",
  right: 27,
  maxWidth: 300,
  width: "100%",
  background: "white",
  marginTop: 8,
  borderRadius: 4,
  boxShadow: "0 1px 10px 0 rgba(9,30,66,0.13)",
  "@media(max-width: 600px)": {
    width: "100vw",
    height: 100,
    bottom: 0,
    overflowY: "auto",
    maxWidth: "none",
    left: 0,
    margin: 0
  },
  div: {
    "&:last-child": {
      marginBottom: 0
    }
  }
});

const listStyle = css({
  listStyleType: "none",
  width: "100%",
  background: "white",
  padding: 14,
  margin: 0,
  div: {
    "&:last-child": {
      marginBottom: 0
    }
  }
});

const legendMargin = css({
  marginBottom: 12,
  display: "flex"
});

const headerStyle = css({
  display: "none",
  width: "100%",
  backgroundColor: "#FFF9E1",
  "@media(max-width: 600px)": {
    display: "inline-block"
  }
});

const footerStyle = css({
  display: "inline-block",
  width: "100%",
  backgroundColor: "#FFF9E1",
  "@media(max-width: 600px)": {
    display: "none"
  }
});

const getDisclaimer = (className, dividerBottom) => {
  const divider = (
    <div
      style={{ width: "100%", borderBottom: "1px solid #DEDEDE", height: 1 }}
    />
  );
  return (
    <div className={className}>
      {!dividerBottom ? divider : null}
      <p
        style={{
          paddingLeft: 14,
          paddingRight: 14,
          margin: "4px 0px 4px 0px",
          fontSize: 11,
          textAlign: "center"
        }}
      >
        You will select your table/seats prior to check out
      </p>
      {dividerBottom ? divider : null}
    </div>
  );
};

const Legend = ({ ticketTypeColors, ticketTypes }) => {
  const colorRow = [];
  for (var key in ticketTypes) {
    const name = ticketTypes[key];
    const color = ticketTypeColors[key];
    colorRow.push({ name, color });
  }
  const convertToHexString = num => ("000000" + num.toString(16)).substr(-6);
  const header = getDisclaimer(headerStyle, true);
  const footer = getDisclaimer(footerStyle, false);
  return (
    <div className={legendStyle}>
      {header}
      <ul className={listStyle}>
        {colorRow.map(({ name, color }, i) => {
          return (
            <li className={legendMargin}>
              <div
                style={{
                  float: "left",
                  marginRight: 8,
                  paddingTop: 2,
                  height: 14
                }}
              >
                <div
                  style={{
                    width: 14,
                    height: 14,
                    backgroundColor: `#${convertToHexString(color)}`
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: 12
                }}
              >
                {name}
              </div>
            </li>
          );
        })}
      </ul>
      {footer}
    </div>
  );
};

class TicketMapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      libraryLoaded: false,
      loaded: false,
      loading: false,
      seatingMap: false
    };
  }

  componentWillMount() {
    const { getAllSeatingMaps, event, ticketSelection } = this.props;
    const eventId = event.id;
    const eventDateId = ticketSelection.selectedDateId;
    getAllSeatingMaps(eventId, eventDateId);
  }

  ticketTypeIsIncludedInSeatingMap = ticketTypeId => {
    const { event } = this.props;
    const seatingMaps = event.data.seatingMaps;
    if (!seatingMaps || seatingMaps.length === 0) {
      return false;
    }
    const seatingMap = seatingMaps[0];
    return (
      seatingMap.ticketTypeSet.findIndex(
        id => String(id) === String(ticketTypeId)
      ) > -1
    );
  };

  getTicketTypes() {
    const { event } = this.props;
    return event.data.ticketTypes
      .concat(event.data.packagedTickets)
      .filter(
        ticketType =>
          !ticketType.disabled &&
          !ticketType.deleted &&
          ticketType.onSale &&
          !ticketType.isDonation
      )
      .filter(ticketType =>
        this.ticketTypeIsIncludedInSeatingMap(ticketType._id)
      )
      .map(ticketType => String(ticketType._id));
  }

  getTicketTypeMap() {
    const { event } = this.props;
    return event.data.ticketTypes
      .concat(event.data.packagedTickets)
      .filter(ticketType => {
        return (
          !ticketType.disabled &&
          !ticketType.deleted &&
          ticketType.onSale &&
          !ticketType.isDonation
        );
      })
      .filter(ticketType =>
        this.ticketTypeIsIncludedInSeatingMap(ticketType._id)
      )
      .reduce((map, ticketType) => {
        map[String(ticketType._id)] = ticketType.name;
        return map;
      }, {});
  }

  componentWillUpdate(nextProps, nextState) {
    const { seatingMap } = nextProps;
    const { libraryLoaded, loaded, loading } = nextState;
    if (
      libraryLoaded &&
      !loaded &&
      !loading &&
      seatingMap.seatingMaps.length > 0
    ) {
      this.setState({ loading: true });
      const ticketTypes = this.getTicketTypes();
      SeatingMap.createTicketMappingView(
        seatingMap.seatingMaps[0].seatingMapData,
        {},
        config("API_URL"),
        ticketTypes
      ).then(seatingMap => {
        this.setState({ loaded: true, seatingMap });
      });
    }
  }

  render() {
    const { libraryLoaded, seatingMap } = this.state;
    const ticketTypes = this.getTicketTypeMap();
    const seatingMapInfo = this.state.loaded ? (
      <div>
        <Legend
          ticketTypes={ticketTypes}
          ticketTypeColors={SeatingMap.getCurrentMap().getTicketTypeColorMap()}
        />
        <Zoom seatingMap={seatingMap} left />
      </div>
    ) : (
      <div class="loading loading-lg" />
    );
    return (
      <div id="seatingMap" className={seatingMapStyle}>
        {!libraryLoaded ? (
          <div>
            <div class="loading loading-lg" />
            <Loadable
              // Can be sync or async
              fn={() => import("@humanitix/humanitix-seating-map")}
              error={err => "Oops, an error occurred: " + err.message}
              loading={() => {}}
              success={HumanitixSeatingMap => {
                this.setState({ libraryLoaded: true });
                SeatingMap = HumanitixSeatingMap.SeatingMap;
              }}
            />
          </div>
        ) : (
          seatingMapInfo
        )}
      </div>
    );
  }
}

TicketMapping = connect(
  state => {
    return {
      event: state.event,
      ticketSelection: state.ticketSelection,
      seatingMap: state.seatingMap
    };
  },
  {
    getAllSeatingMaps
  }
)(TicketMapping);

export default TicketMapping;



// WEBPACK FOOTER //
// ./components/TicketMapping.js